import React, { Component, Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import { withRouter } from "react-router";
import { Table, Pagination, Button, Input, Select } from 'antd';

@inject('goodsGroupStore')
@observer
class GoodsGroupList extends Component {
  state = {
    groupNm: '',
  };

  onPageChange = (pageIdx) => {
    // console.log('page:', page);
    this.props.goodsGroupStore.disGoodsGroupList(pageIdx);
  };

  onSearch = () => {
    this.props.goodsGroupStore.onChangValue('groupNm', this.state.groupNm);
    this.props.goodsGroupStore.disGoodsGroupList(1);
  };

  onPressEnter = (e) => {
    if (e.key === 'Enter') {
      this.onSearch();
    }
  };

  render() {
    const {
      valCondition,
      onChangValue,
      goodsGroupList,
      pageInfo,

      onViewMode,
      disGoodsGroupList,
      disGoodsGroupDetail,
      goodsGroupUserYn
    } = this.props.goodsGroupStore;
    const { 
      groupNm,
    } = this.state;
    const columns = [
      { title: 'No', dataIndex: 'RNUM',  width: '7%', align: 'center' },
      { title: '상품군', dataIndex: 'groupNm', width: '45%', align: 'center' },
      { title: '상품 갯수', dataIndex: 'gdCdCnt', width: '10%', align: 'center' },
      { title: '상품군 정렬순서', dataIndex: 'groupOrder', width: '15%', align: 'center' },
      { title: '사용여부', dataIndex: 'useYn', width: '23%', align: 'center',
        render: (item, record) => { return(
          <Button 
            onClick={(e)=>{
              e.stopPropagation();
              goodsGroupUserYn(record.groupCd, item);
            }}
          >{item === "Y" ? <Fragment>사용</Fragment> : <Fragment>미사용</Fragment>}
          </Button>
        )}
      },
    ];
    return (
      <Fragment>
        <div className="search-box mo_srch_box">
          <div className="search-content" style={{float:'left'}}>
            <span className="mo_srch">
              <span className="labal2">사용여부</span>
              <Select
                style={{ width: 150, marginRight: '20px' }}
                value={valCondition.useYn}
                onChange={(value)=>{
                  onChangValue('useYn', value);
                  this.onSearch();
                }}
              >
                <Select.Option key={''}>전체</Select.Option>
                <Select.Option key={'Y'}>사용</Select.Option>
                <Select.Option key={'N'}>미사용</Select.Option>
              </Select>
            </span>
            <span className="mo_srch">
              <span className="labal2">상품군명</span> 
              <Input 
                placeholder="상품군명을 입력하세요"
                value={groupNm}
                onChange={(e)=>this.setState({groupNm: e.target.value})}
                onPressEnter={this.onPressEnter}
                style={{ width: 200 }}
              />
            </span>
          </div>
          <div className="search-button">
            <Button type="primary" onClick={this.onSearch}>조회</Button>
          </div>
        </div>
        <div className="button-group">
          <Select
            style={{ width: 120 }}
            value={valCondition.recordCountPerPage}
            onChange={(value)=>disGoodsGroupList(1, value)}
          >
            <Select.Option value={10}>10개 보기</Select.Option>
            <Select.Option value={20}>20개 보기</Select.Option>
            <Select.Option value={30}>30개 보기</Select.Option>
            <Select.Option value={40}>40개 보기</Select.Option>
          </Select>
          <h4 style={{ color: 'red' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            ※상품군명에 꼭 하계/동계를 기입하셔야 합니다.
            {/*(2022/3/18 요청사항- 전직원의 구매제한초기화. 2024/8/31이후 삭제 가능)*/}
          </h4>
          <div className="button-right">
            <ul>
              <li>
                <Button 
                  type="primary"
                  onClick={()=>onViewMode('add')}
                >추가</Button>
              </li>
            </ul>
          </div>
        </div>

        <Table
          rowKey={(record)=>record.RNUM}
          columns={columns} 
          dataSource={goodsGroupList} 
          //scroll={{ x: 1300, y:300 }}
          pagination={false}
          onRow={(record, rowIndex) => {
            return {
              onClick: e => {
                e.preventDefault();
                disGoodsGroupDetail(record);
              },
            };
          }}
        />
        <br />
        <div className="page_nav_ct">
          <Pagination
            showSizeChanger={false}
            current={pageInfo !== null ? pageInfo.pageIndex : 1}
            total={pageInfo !== null ? pageInfo.totalCnt : 0}
            pageSize={pageInfo !== null ? pageInfo.recordCountPerPage : 0}
            onChange={this.onPageChange}
          />
        </div>
      </Fragment>
    );
  }

}

export default withRouter(GoodsGroupList);
